import { call } from "./calls";

export const StoreDynamic = {
    create: (obj) => call('/store/dynamic', "POST", obj),
    get: (id) => call(`/store/dynamic/${id}`),
    update: (obj) => call(`/store/dynamic/${obj.id}`, "PUT", obj),
    delete: (obj) => call('/store/dynamic', "DELETE", obj)
};